import { FuseNavigation } from '@fuse/types';

export const userNavigation: FuseNavigation[] = [
    {
        id: 'applications',
        title: 'Applications',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'campaign',
                title: 'Campaign',
                translate: 'NAV.CAMPAIGN.TITLE',
                type: 'item',
                icon: 'work_outline',
                url: '/campaigns',
            },
        ],
    },
];
